/** URL param that deep-links to a single event (e.g. from a notification). */
export const EVENT_ID_SEARCH_PARAM = 'event_id';
